module.exports = __webpack_public_path__ + "media/PAG72-01.c7d6dc2d.mp3";